"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function UTokenIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { fill: "#367dbf", d: "m12,24c6.627,0,12-5.373,12-12S18.627,0,12,0,0,5.373,0,12s5.373,12,12,12Z" }),
        react_1.default.createElement("path", { fill: "#FFFFFF", d: "m12.944,7.191v8.327l-2.667-1.105V6.089l-2.961-1.224v11.438l7.749,3.202.84-.84v-10.251l-2.961-1.224Z" })));
}
exports.default = UTokenIcon;
